import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: 'restricted',
    loadComponent: () => import('./guest-restricted.component').then((m) => m.GuestRestrictedComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class guestRestrictedRoutingModule {
  static routes = admin;
}